import { FC, useRef } from 'react';

import { Stack } from '@bonusly/design-system';
import { useCurrentUser } from '@bonusly/who-am-i';

import { Feedback } from '../../lib';
import { useFeedbackContext } from '../context/feedback-context';
import { CompleteMessage } from '../message';
import { EvaluationContext } from './context';
import { EvaluationHeader } from './evaluation-header';
import { ExpiredActions } from './expired-actions';
import { FeedbackMessages } from './feedback-messages';
import { FeedbackReference } from './feedback-reference';
import { PendingResponse } from './pending-response';
import { UnrequestedFeedbackHeader } from './unrequested-feedback-header';

interface FeedbackContentProps {
	evaluation: Feedback;
	variant?: 'responseModal';
}

export const FeedbackContent: FC<FeedbackContentProps> = ({ evaluation, variant }) => {
	const user = useCurrentUser();
	// This is stored in a ref so the state of a thread having a "new" message
	// will persist even after the data is updated in the back end and re-rendered
	// on the front end. Once the user navigates to a different filter and back
	// the ref will reset and any display indicating the new message will be removed.
	const isNew = useRef(!evaluation.seenBy(user.id));
	const { confirmDelete } = useFeedbackContext();

	return (
		<EvaluationContext value={evaluation}>
			{evaluation.request ? (
				<EvaluationHeader mb={2} isNew={isNew.current} />
			) : (
				<UnrequestedFeedbackHeader evaluation={evaluation} isNew={isNew.current} createdAt={evaluation.createdAt} />
			)}
			<Stack spacing={4} p={3}>
				{evaluation.request?.text && (
					<CompleteMessage date={evaluation.createdAt} text={evaluation.request.text} userId={evaluation.receiverId} userName={evaluation.receiver.name} />
				)}

				<FeedbackReference reference={evaluation.reference} />
				{confirmDelete != undefined && <ExpiredActions />}
				<PendingResponse />
				<FeedbackMessages feedback={evaluation} variant={variant} />
			</Stack>
		</EvaluationContext>
	);
};
